import { Routes } from '@angular/router';
import {AuthGuard} from "../auth.guard";
import {UserInfoComponent} from "./user-info/user-info.component";
import {AccessDeniedComponent} from "./access-denied/access-denied.component";
import {TemplatesComponent} from "./templates/templates.component";
import {ISFSubmissionList} from "./isf/list/isf.list";

export const routes: Routes = [
	{
		path:'',
		component: TemplatesComponent,
		canActivate: [AuthGuard]
	},
	{
		path:'templates',
		component: TemplatesComponent,
		canActivate: [AuthGuard]
	},
	{
		path:'isf',
		component: ISFSubmissionList,
		canActivate: [AuthGuard]
	},
	{
		path: 'access-denied',
		component: AccessDeniedComponent,
		canActivate: [AuthGuard]
	},
	{
		path: 'user',
		component: UserInfoComponent,
		canActivate: [AuthGuard],
		// The user need to have these roles to access page
		//data: { roles: ['Importer'] }
	},
	{
		path: 'deny',
		component: AccessDeniedComponent,
		canActivate: [AuthGuard],
	}
];
